import { TFiveOrSixUtpBlock } from 'shared/types/utp';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

interface IFiveUtpBlockProps {
  items: TFiveOrSixUtpBlock;
  theme?: 'white' | 'blue';
}

export const FiveOrSixUtpBlock: React.FC<IFiveUtpBlockProps> = ({ items, theme = 'blue' }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {items.map(({ title, image }, key) => (
        <div key={key} className={clsx(styles['item'], styles[theme])}>
          <div className={styles['title']}>
            {title.map(({ value, isBold }, key) => {
              if (isBold) {
                return (
                  <span key={key} className={styles['bold']}>
                    {value}
                  </span>
                );
              }

              return value;
            })}
          </div>
          <div className={clsx(styles['image'], styles[image])} />
        </div>
      ))}
    </div>
  );
};
